export enum ChoiceStyle {
    Dropdown = "dropdown",
    Inline = "inline"
}
